module.exports = __webpack_public_path__ + "img/afb3b24.jpg";